<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Gestión de cubicacion</h1>
                <br>
                <v-card>
                    <v-card-text>
                        <form @submit.prevent="agregar()" ref="form" lazy-validation>
                            <v-layout>
                                <v-flex xs12 sm2>
                                    <tipo-item-select v-model="d.item_tipo_id"></tipo-item-select>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <item-select :tipo="d.item_tipo_id" v-model="d.item_id"></item-select>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <panel-caract label="Tipo de panel" caract="tipo" v-model="d.panel_tipo"></panel-caract>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <panel-caract label="Espesor" caract="esp" v-model="d.panel_espesor"></panel-caract>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field label="M2" v-model="d.m2"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12 sm2>
                                    <v-text-field label="Factor ocupación panel" v-model="fact_ocp_pan" @change="setConfigVal('fact_ocp_pan',fact_ocp_pan)"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field label="Factor ocupación camara" v-model="fact_ocp_cam" @change="setConfigVal('fact_ocp_cam',fact_ocp_cam)"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field label="Factor ocupación equipo" v-model="fact_ocp_equ" @change="setConfigVal('fact_ocp_equ',fact_ocp_equ)"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    <v-btn type="submit" dark color="green" :loading="loading">
                                        Agregar
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-data-table
                        :headers="headers"
                        :items="items"
                        :pagination.sync="pag"
                        :total-items="totalItems"
                        :loading="loading"
                        rows-per-page-text="Filas por pagina"
                        no-data-text="No hay datos"
                        disable-initial-sort
                        item-key="id"
                        class="tabla-compacta-col"
                >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-center">{{ (props.item.item_tipo_id)? props.item.item_tipo.desig : '' }}</td>
                        <td class="text-xs-center">{{ (props.item.item_id)? props.item.item.descripcion : '' }}</td>
                        <td class="text-xs-center">{{ props.item.panel_tipo }}</td>
                        <td class="text-xs-center">{{ props.item.panel_espesor }}</td>
                        <td class="text-xs-right">
                            <v-edit-dialog
                                    save-text="Guardar"
                                    cancel-text="Cancelar"
                                    large
                                    lazy
                                    style="width: 100%"
                                    @save="editar(props.item)">
                                <span style="width: 100%">{{ (props.item.m2)?props.item.m2 : 0 }}</span>
                                <v-text-field
                                        slot="input"
                                        v-model="m2Nueva"
                                        label="Editar"
                                        single-line
                                        type="number"
                                        hint="Presione <kbd>enter</kbd> para guardar"
                                >
                                </v-text-field>
                            </v-edit-dialog>
                        </td>
                        <td class="text-xs-center">
                            <v-btn flat icon @click.native="eliminar(props.item.id)" color="red" :loading="loadingDel === props.item.id">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import fleteMixin from '../../mixins/flete_cubicacion';
    import configMixin from '../../mixins/config';
    import moneda from '../../filters/moneda';
    import {mapActions} from 'vuex';
    import panelCaract from '../../components/PanelCaracterisitica'
    import TipoItemSelect from '../../components/TipoItemSelect'
    import ItemSelect from '../../components/ItemSelect'

    function initialValue() {
        return {
            item_tipo_id: '',
            item_id: '',
            panel_tipo: '',
            panel_espesor: '',
            m2: '',
        }
    }

    export default {
        name: "flete_seguro",
        mixins: [fleteMixin, configMixin],
        filters: {moneda},
        components: {panelCaract, TipoItemSelect,ItemSelect},
        data() {
            return {
                loading: false,
                loadingDel: -1,
                d: initialValue(),
                m2Nueva: 0,
                headers: [
                    {text: 'Tipo de item', value: 'item_tipo_id', align: 'center'},
                    {text: 'Item', value: 'item_id', align: 'center'},
                    {text: 'Tipo de panel', value: 'panel_tipo', align: 'center'},
                    {text: 'Espesor', value: 'panel_espesor', align: 'center'},
                    {text: 'M2', value: 'm2', align: 'center'},
                    {text: 'Opciones', value: '', align: 'center', sortable: false},
                ],
                items: [],
                pag: {},
                totalItems: 0,
                fact_ocp_pan: 0,
                fact_ocp_equ: 0,
                fact_ocp_cam: 0

            }
        },
        mounted() {
            this.configGet('fact_ocp_pan', r => {
                this.fact_ocp_pan = r;
            }, err => console.log(err));
            this.configGet('fact_ocp_equ', r => {
                this.fact_ocp_equ = r;
            }, err => console.log(err));
            this.configGet('fact_ocp_cam', r => {
                this.fact_ocp_cam = r;
            }, err => console.log(err));
        },
        watch: {
            pag: {
                handler() {
                    this.tabla();
                },
                deep: true
            }
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            setConfigVal(nom, valor) {
                this.configSetByName({
                    nom: nom,
                    valor: valor
                }, r => {
                    this.msjShow(r);
                }, err => {
                    this.msjShow({tipo: 2, txt: 'Error al guardar configuración'});
                })
            },
            tabla() {
                this.loading = true;
                this.fleteCubicacionIndex(this.pag, r => {
                    this.totalItems = r.total;
                    this.items = r.data;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                });
            },
            agregar() {
                this.loading = true;
                this.fleteCubicacionStore(this.d, r => {
                    this.msjShow(r);
                    this.tabla();
                    this.d = initialValue();
                    this.loading = false;
                }, err => {
                    this.msjShow({txt: 'Error al guardar', tipo: 'error'});
                    this.loading = false;
                });
            },
            editar(item) {
                this.loading = true;
                this.fleteCubicacionUpdate(item.id, {m2: this.m2}, r => {
                    this.msjShow(r);
                    item.m2 = this.m2Nueva;
                    this.m2Nueva = '';
                    this.loading = false;
                }, err => {
                    console.error('Error');
                    this.loading = false;
                });
                return false;
            },
            eliminar(id) {
                this.loadingDel = id;
                this.fleteCubicacionDestroy(id, r => {
                    this.msjShow(r);
                    this.tabla();
                    this.loadingDel = -1;
                }, err => {
                    this.msjShow({txt: 'Error al eliminar', tipo: 'error'});
                    this.loadingDel = -1;
                });
            },
        }
    }
</script>

<style>
    .v-menu__activator a {
        width: 100% !important;
        text-align: right !important;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/flete/cubicacion.vue